import React from 'react';

const strokeProps = {
  stroke: 'currentColor',
  fill: 'none',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const RAIL_ICONS = {
  'fa-th-large': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="3" width="8" height="8" rx="1.5" {...strokeProps} />
      <rect x="13" y="3" width="8" height="8" rx="1.5" {...strokeProps} />
      <rect x="3" y="13" width="8" height="8" rx="1.5" {...strokeProps} />
      <rect x="13" y="13" width="8" height="8" rx="1.5" {...strokeProps} />
    </svg>
  ),
  'fa-building': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="3" width="16" height="18" rx="1" {...strokeProps} />
      <line x1="8" y1="7" x2="8" y2="7.01" {...strokeProps} />
      <line x1="12" y1="7" x2="12" y2="7.01" {...strokeProps} />
      <line x1="16" y1="7" x2="16" y2="7.01" {...strokeProps} />
      <line x1="8" y1="11" x2="8" y2="11.01" {...strokeProps} />
      <line x1="12" y1="11" x2="12" y2="11.01" {...strokeProps} />
      <line x1="16" y1="11" x2="16" y2="11.01" {...strokeProps} />
    </svg>
  ),
  'fa-user-circle': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z" {...strokeProps} />
      <path d="M9 12l2 2 4-4" {...strokeProps} />
    </svg>
  ),
  'fa-users': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="9" cy="8" r="3" {...strokeProps} />
      <circle cx="17" cy="9" r="2.5" {...strokeProps} />
      <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" {...strokeProps} />
      <path d="M15 20c0-2.2-.7-4.1-2-5.4" {...strokeProps} />
    </svg>
  ),
  'fa-credit-card': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="2.5" y="5" width="19" height="14" rx="2" {...strokeProps} />
      <line x1="2.5" y1="10" x2="21.5" y2="10" {...strokeProps} />
      <line x1="6" y1="15" x2="10" y2="15" {...strokeProps} />
    </svg>
  ),
  'fa-user-md': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="8" r="3.5" {...strokeProps} />
      <path d="M5 20c0-4 3-7 7-7s7 3 7 7" {...strokeProps} />
    </svg>
  ),
  'fa-heartbeat': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 20s-7-4.4-9.5-9C.9 7.6 3 4 6.5 4c2 0 3.4 1.1 4 2.3C11.1 5.1 12.5 4 14.5 4 18 4 20.1 7.6 21.5 11c-2.5 4.6-9.5 9-9.5 9z" {...strokeProps} />
    </svg>
  ),
  'fa-calendar': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="4.5" width="18" height="16" rx="2" {...strokeProps} />
      <line x1="3" y1="9.5" x2="21" y2="9.5" {...strokeProps} />
      <line x1="7.5" y1="2.5" x2="7.5" y2="6.5" {...strokeProps} />
      <line x1="16.5" y1="2.5" x2="16.5" y2="6.5" {...strokeProps} />
    </svg>
  ),
  'fa-cube': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="3.5" width="14" height="17" rx="1.5" {...strokeProps} />
      <rect x="9" y="2" width="6" height="3" rx="1" {...strokeProps} />
      <line x1="8" y1="10" x2="16" y2="10" {...strokeProps} />
      <line x1="8" y1="14" x2="16" y2="14" {...strokeProps} />
    </svg>
  ),
  'fa-cog': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="3" {...strokeProps} />
      <path d="M19.4 13.5a7.9 7.9 0 000-3l1.9-1.5-2-3.4-2.2.8a7.7 7.7 0 00-2.6-1.5L14 2.5h-4l-.5 2.4a7.7 7.7 0 00-2.6 1.5l-2.2-.8-2 3.4L4.6 10.5a7.9 7.9 0 000 3L2.7 15l2 3.4 2.2-.8c.8.7 1.7 1.2 2.6 1.5l.5 2.4h4l.5-2.4c1-.3 1.8-.8 2.6-1.5l2.2.8 2-3.4z" {...strokeProps} />
    </svg>
  ),
  'fa-lock': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="10.5" width="14" height="10" rx="2" {...strokeProps} />
      <path d="M8 10.5V7a4 4 0 018 0v3.5" {...strokeProps} />
    </svg>
  ),
  'fa-envelope': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="2" {...strokeProps} />
      <path d="M3 7l9 6 9-6" {...strokeProps} />
    </svg>
  ),
  'fa-mobile': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="7" y="2" width="10" height="20" rx="2" {...strokeProps} />
      <line x1="12" y1="18" x2="12" y2="18.01" {...strokeProps} />
    </svg>
  ),
  'fa-search': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="11" cy="11" r="7" {...strokeProps} />
      <line x1="21" y1="21" x2="16.65" y2="16.65" {...strokeProps} />
    </svg>
  ),
  'fa-file-text': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" {...strokeProps} />
      <polyline points="14 2 14 8 20 8" {...strokeProps} />
      <line x1="8" y1="13" x2="16" y2="13" {...strokeProps} />
      <line x1="8" y1="17" x2="13" y2="17" {...strokeProps} />
    </svg>
  ),
  'fa-chart-bar': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <line x1="4" y1="20" x2="20" y2="20" {...strokeProps} />
      <rect x="5" y="11" width="3.5" height="9" rx="0.5" {...strokeProps} />
      <rect x="10.25" y="7" width="3.5" height="13" rx="0.5" {...strokeProps} />
      <rect x="15.5" y="4" width="3.5" height="16" rx="0.5" {...strokeProps} />
    </svg>
  ),
  'fa-bars': (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <line x1="4" y1="7" x2="20" y2="7" {...strokeProps} />
      <line x1="4" y1="12" x2="20" y2="12" {...strokeProps} />
      <line x1="4" y1="17" x2="20" y2="17" {...strokeProps} />
    </svg>
  ),
};

const RailIcon = ({ name, className = 'rail-icon' }) => {
  const icon = RAIL_ICONS[name];
  if (!icon) {
    return (
      <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
        <circle cx="12" cy="12" r="9" {...strokeProps} />
      </svg>
    );
  }
  return <span className={className}>{icon}</span>;
};

export default RailIcon;
